import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/js/rem.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import MetaInfo from "vue-meta-info";
import {
  get,
  post
} from "@/assets/js/request.js"
import VueClipboard from 'vue-clipboard2'
Vue.prototype.$http = {
  get,
  post
};

Vue.use(MetaInfo);
Vue.use(ElementUI);
Vue.use(VueClipboard)
Vue.config.productionTip = false

router.beforeEach((to, from, next) => {
  let pathArr = ["/", "/productCenter", "/solution", "/researchConsulting", "/memberService", "/aboutUs"];
  let pathArr2 = ["/", "/productCenter/", "/solution/", "/researchConsulting/", "/memberService/", "/aboutUs/"];
  for (let i in pathArr) {
    if (pathArr[i] == to.path || pathArr2[i] == to.path) store.commit("change", Number(i));
  }
  next();
});
var timer = 1;
router.afterEach((to, from, next) => { //点击头部切换页面，自动刷新回滚到顶部
  cancelAnimationFrame(timer);
  timer = requestAnimationFrame(function fn() {
    var oTop = document.body.scrollTop || document.documentElement.scrollTop;
    if (oTop > 0) {
      document.body.scrollTop = document.documentElement.scrollTop = oTop - 250;
      timer = requestAnimationFrame(fn);
    } else {
      cancelAnimationFrame(timer);
    }
  });
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')